import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      title: 'エリア・パーキング情報検索'
    },
    component: () =>
      import(/* webpackChunkName: "Common" */ '../views/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: 'エリア・パーキング情報検索'
    },
    component: () =>
      import(/* webpackChunkName: "Common" */ '../views/Login.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () =>
      import(/* webpackChunkName: "Admin" */ '../views/admin/Index.vue'),
    children: [
      {
        path: 'contractor/list',
        name: 'ContractorList',
        meta: {
          title: 'エリア・パーキング - 契約者一覧',
          pageKey: 'ContractorList'
        },
        component: () =>
          import(
            /* webpackChunkName: "Contractor" */ '../views/admin/contractor/ContractorList.vue'
          )
      },
      {
        path: 'contractor/detail/:code',
        name: 'ContractorDetail',
        meta: {
          title: 'エリア・パーキング - 契約者詳細',
          pageKey: 'ContractorList'
        },
        component: () =>
          import(
            /* webpackChunkName: "Contractor" */ '../views/admin/contractor/ContractorDetail.vue'
          )
      },
      {
        path: 'parkinglot/list',
        name: 'ParkinglotList',
        meta: {
          title: 'エリア・パーキング - 駐車場一覧',
          pageKey: 'ParkinglotList'
        },
        component: () =>
          import(
            /* webpackChunkName: "Parkinglot" */ '../views/admin/parkinglot/ParkinglotList.vue'
          )
      },
      {
        path: 'parkinglot/detail/:code',
        name: 'ParkinglotDetail',
        meta: {
          title: 'エリア・パーキング - 駐車場詳細',
          pageKey: 'ParkinglotList'
        },
        component: () =>
          import(
            /* webpackChunkName: "Parkinglot" */ '../views/admin/parkinglot/ParkinglotDetail.vue'
          )
      }
    ]
  },
  { path: '/:pathMatch(.*)*', redirect: '/login' }
]
const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_APP_BASE_URL || '/'),
  routes
})

router.beforeEach((to, from, next) => {
  const pageKey = to.meta.pageKey
  const title = to.meta.title || 'エリア・パーキング'
  store.dispatch('setPageKey', [pageKey])
  store.dispatch('setPageTitle', title)
  document.title = title
  next()
})
export default router
